import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "../utils/classes";

const BlockQuote = ({
	author,
	jobTitle = "",
	institution,
	active = false,
	isBorderNone = false,
	className = "",
	children,
}) => {
	return (
		<div
			className={classes(
				"bq__item",
				active && "bq__item--active",
				isBorderNone && "bq__item--border-none",
				className,
			)}
		>
			<div className="bq__item-message">{children}</div>
			<div className="bq__item-author">{author}</div>
			{jobTitle ? <div className="bq__item-job-title">{jobTitle}</div> : null}
			<div className="bq__item-institution">{institution}</div>
		</div>
	);
};

BlockQuote.propTypes = {
	author: string.isRequired,
	jobTitle: string,
	institution: string.isRequired,
	active: bool,
	isBorderNone: bool,
	className: string,
	children: node.isRequired,
};

export default BlockQuote;
